export default "__VITE_ASSET__B7_SJhPs__"